import {Navigate, useRoutes} from "react-router-dom";
import DashboardLayout from "../layouts/dashboard";
import {PATH_AFTER_LOGIN} from "../config";
import {
    BusEditPage,
    BusList,
    BusNew,
    CarriersEditPage,
    CarriersList,
    CarriersNew,
    CustomersEditPage,
    CustomersList,
    CustomersNew,
    DeparturesList,
    DeparturesListEditPage,
    DeparturesListNew,
    DiscountsEditPage,
    DiscountsList,
    DiscountsNew,
    HomePage,
    InsuranceEditPage,
    InsuranceList,
    InsuranceNew,
    InvoicePage, ItemsEditPage, ItemsNewPage, ItemsPage,
    LinesList,
    LinesListEditPage,
    LinesListNew,
    LocationsList,
    LocationsListEditPage,
    LocationsListNew,
    Login,
    MonthlyTicketsList,
    MonthlyTicketsListEditPage,
    MonthlyTicketsListNew,
    PriceList,
    PriceListEditPage,
    PriceListNew,
    PriceListStationEditPage,
    PriceListStationNew,
    PriceStationsList,
    ReportsPage,
    ServicesEditPage,
    ServicesList,
    ServicesNew,
    SettingsPage,
    StationList,
    StationListEditPage,
    StationListNew,
    StationServicesPage,
    TimesList,
    TimesListNew
} from "./elements";
import AuthGuard from "../auth/AuthGuard";
import {PATH_AUTH, PATH_DASHBOARD} from "./path";
import GuestGuard from "../auth/GuestGuard";

export default function Router() {
    return useRoutes([
        {
            path: "auth",
            children: [
                {
                    path: PATH_AUTH.login,
                    element: (
                        <GuestGuard>
                            <Login/>
                        </GuestGuard>
                    )
                }
            ]
        },
        {
            path: "",
            element: (
                <AuthGuard>
                    <DashboardLayout/>
                </AuthGuard>
            ),
            children: [
                {element: <Navigate to={PATH_AFTER_LOGIN} replace/>, index: true},
                {path: PATH_DASHBOARD.general.app, element: <HomePage/>},
                {path: PATH_DASHBOARD.general.stationServices, element: <StationServicesPage/>},
                {path: PATH_DASHBOARD.general.reports, element: <ReportsPage/>},
                {path: PATH_DASHBOARD.general.invoices, element: <InvoicePage/>},
                {path: PATH_DASHBOARD.general.settings, element: <SettingsPage/>},
                {
                    path: PATH_DASHBOARD.discounts.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.discounts.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.discounts.list, element: <DiscountsList/>},
                        {path: PATH_DASHBOARD.discounts.new, element: <DiscountsNew/>},
                        {path: ":name/edit", element: <DiscountsEditPage/>},
                    ]
                },
                {
                    path: PATH_DASHBOARD.bus.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.bus.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.bus.list, element: <BusList/>},
                        {path: PATH_DASHBOARD.bus.new, element: <BusNew/>},
                        {path: ":name/edit", element: <BusEditPage/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.priceList.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.priceList.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.priceList.list, element: <PriceList/>},
                        {path: PATH_DASHBOARD.priceList.new, element: <PriceListNew/>},
                        {path: PATH_DASHBOARD.priceList.newStation, element: <PriceListStationNew/>},
                        {path: PATH_DASHBOARD.priceList.stationsList, element: <PriceStationsList/>},
                        {path: PATH_DASHBOARD.priceList.stationsServicesList, element: <ItemsPage/>},
                        {path: PATH_DASHBOARD.priceList.stationsServicesAdd, element: <ItemsNewPage/>},
                        {path: ":name/edit", element: <PriceListEditPage/>},
                        {path: ":name/edit-station", element: <PriceListStationEditPage/>},
                        {path: ":name/edit-station-service", element: <ItemsEditPage/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.stationList.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.priceList.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.stationList.list, element: <StationList/>},
                        {path: PATH_DASHBOARD.stationList.new, element: <StationListNew/>},
                        {path: ":name/edit", element: <StationListEditPage/>},
                    ]
                },
                {
                    path: PATH_DASHBOARD.locationList.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.locationList.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.locationList.list, element: <LocationsList/>},
                        {path: PATH_DASHBOARD.locationList.new, element: <LocationsListNew/>},
                        {path: ":name/edit", element: <LocationsListEditPage/>},
                    ]
                },
                {
                    path: PATH_DASHBOARD.linesList.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.linesList.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.linesList.list, element: <LinesList/>},
                        {path: PATH_DASHBOARD.linesList.new, element: <LinesListNew/>},
                        {path: ":name/edit", element: <LinesListEditPage/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.departuresList.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.departuresList.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.departuresList.list, element: <DeparturesList/>},
                        {path: PATH_DASHBOARD.departuresList.new, element: <DeparturesListNew/>},
                        {path: ":name/edit", element: <DeparturesListEditPage/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.timesList.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.timesList.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.timesList.list, element: <TimesList/>},
                        {path: PATH_DASHBOARD.timesList.new, element: <TimesListNew/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.monthlyTicketsList.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.monthlyTicketsList.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.monthlyTicketsList.list, element: <MonthlyTicketsList/>},
                        {path: PATH_DASHBOARD.monthlyTicketsList.new, element: <MonthlyTicketsListNew/>},
                        {path: ":name/edit", element: <MonthlyTicketsListEditPage/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.customers.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.customers.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.customers.list, element: <CustomersList/>},
                        {path: PATH_DASHBOARD.customers.new, element: <CustomersNew/>},
                        {path: ":name/edit", element: <CustomersEditPage/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.carriers.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.carriers.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.carriers.list, element: <CarriersList/>},
                        {path: PATH_DASHBOARD.carriers.new, element: <CarriersNew/>},
                        {path: ":name/edit", element: <CarriersEditPage/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.insurance.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.insurance.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.insurance.list, element: <InsuranceList/>},
                        {path: PATH_DASHBOARD.insurance.new, element: <InsuranceNew/>},
                        {path: ":name/edit", element: <InsuranceEditPage/>}
                    ]
                },
                // {
                //     path: PATH_DASHBOARD.items.root,
                //     children: [
                //         {element: <Navigate to={ PATH_DASHBOARD.priceList.stationsServicesList} replace/>, index: true},
                //         {path:  PATH_DASHBOARD.priceList.stationsServicesList, element: <ServicesList/>},
                //         {path: PATH_DASHBOARD.items.new, element: <ServicesNew/>},
                //         {path: ":name/edit", element: <ServicesEditPage/>}
                //     ]
                // },
            ]
        },
    ]);
}


